import styled from 'styled-components'

export const TipWrap = styled.span`
  display: inline-flex;
  align-items: center;
  flex: none;
  cursor: help;
`
